import UploadArea from "./UploadArea";
import { parseErrorMessage } from "../../../utils/parseErrorMessage";

const DesignUpload = ({
  files,
  setFiles,
  figmaUrl,
  setFigmaUrl,
  fileUploadError,
  figmaUrlError,
}) => (
  <div className="app-ai-quote-design-frame">
    <div className="app-ai-quote-design-description">
      <h3>Upload Your Designs / Wireframes</h3>
      <p>
        Please note that the tool supports <span>.png</span>, <span>.jpg</span>,{" "}
        <span>.pdf</span> formats.
        <br />
        If your design is in a different format, please upload screenshots as{" "}
        <span>.png</span> or <span>.jpg</span> files.
      </p>
    </div>
    <div className="app-ai-quote-design-upload">
      <UploadArea files={files} setFiles={setFiles} />
    </div>
    <div className="app-ai-quote-divider">
      <strong className="app-ai-quote-divider-text">or</strong>
    </div>
    <div className="app-ai-quote-design-figma">
      <h3>Figma Design</h3>
      <p>
        Provide the link to your <span>Figma design</span> here. Ensure
        it&apos;s shareable to enable <span>direct access</span>.
      </p>
      <div className="app-ai-quote-form-field">
        <label htmlFor="email">Figma URL</label>
        <input
          type="text"
          id="figma"
          value={figmaUrl}
          onChange={(e) => setFigmaUrl(e.target.value)}
        />
        {figmaUrlError && figmaUrlError.length > 0 && (
          <span className="app-ai-quote-error-input">
            {parseErrorMessage(figmaUrlError)}
          </span>
        )}
      </div>
    </div>
    {fileUploadError && fileUploadError.length > 0 && (
      <span className="app-ai-quote-error-input">
        {parseErrorMessage(fileUploadError)}. Support formats: .png, .jpg, .pdf
      </span>
    )}
  </div>
);

export default DesignUpload;
